module.exports = __webpack_public_path__ + "img/tima.0a510d87.png";